import { NavLink } from "hooks/useCustomNavigation";
import "./index.scss";
import { BreadcrumbContainer } from "components/UI/atoms";

export const Breadcrumb = ({ list, rightSide, customClassname }) => (
  <BreadcrumbContainer>
    <div className={`breadcrumb-content ${customClassname}`}>
      <div className="breadcrumb-links">
        {list.map(({ label, linkTo }, index) => {
          const isLastItem = index + 1 === list.length;
          return isLastItem && !linkTo ? (
            <p key={label}>{label}</p>
          ) : (
            <span key={label}>
              <NavLink to={linkTo} key={label}>
                {label}
              </NavLink>
              {!isLastItem && list.length > 1 && "/ "}
            </span>
          );
        })}
      </div>
      {rightSide}
    </div>
  </BreadcrumbContainer>
);
